module.exports = __webpack_public_path__ + "img/bag_not_ok.2e4a7cbe.svg";